<div class="attachment-item">
    <div
        class="attachment-item-wrapper"
        [ngClass]="{
            'attachment-error': attachment['hasError'] && action === addAttachment
        }"
    >
        <div class="name-image-container" [ngClass]="{ download: action === downloadAttachment }" (click)="openDialog(myTemplate)">
            <div class="icon-container">
                <img src="assets/images/{{ attachment.name | fileType }}" alt="attachment-icon" />
            </div>
            <p class="attachment-name" [ngbTooltip]="attachment.name" container="body">
                {{ attachment.name }}
            </p>
        </div>
        <div class="actions" *ngIf="action === downloadAttachment">
            <p class="download-file medium" (click)="downloadFile()" *ngIf="!showLoader">
                {{ 'download' | translate }}
            </p>
            <div class="download-file" *ngIf="showLoader">
                <app-loader [extraSmallLoader]="true"></app-loader>
            </div>
        </div>
        <div class="actions" *ngIf="action === addAttachment">
            <span
                class="material-symbols-outlined remove-attachment"
                *ngIf="attachment['uploadStatus'] !== uploadingStatus"
                (click)="removeAttachment(attachment)"
            >
                close</span
            >
            <div class="remove-attachment" *ngIf="attachment['uploadStatus'] === uploadingStatus">
                <app-loader [extraSmallLoader]="true"></app-loader>
            </div>
        </div>
    </div>
    <div>
        <span class="has-error" *ngIf="attachment['hasError']">{{ attachment['errorMessage'] | translate }}</span>
    </div>
</div>


<ng-template #myTemplate>
    <span (click)="myDialogRef?.close()"  class="material-symbols-outlined remove-attachment closeB">close</span>
    <img  *ngIf="extension!=='application/pdf' && extension && url" [src]="sanitizer.bypassSecurityTrustUrl('data:'+extension+';base64,' + url)" class="image-preview" />
    <iframe *ngIf="extension==='application/pdf' && extension && url" [src]="sanitizer.bypassSecurityTrustResourceUrl(url)" class="iframe-preview"></iframe>

</ng-template>
